import { render, staticRenderFns } from "./IcoBell.vue?vue&type=template&id=830a11e6"
import script from "./IcoBell.vue?vue&type=script&lang=js"
export * from "./IcoBell.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports